import { SvgIcon, SxProps } from "@mui/material";

import {
  AwsAmazonLinuxInstancesIcon,
  AwsAutoscalingGroupsIcon,
  AwsCloudwatchAlarmsIcon,
  AwsCloudwatchLogGroupsIcon,
  AwsConfigRecordersIcon,
  AwsDynamodbTablesIcon,
  AwsEbsSnapshotsIcon,
  AwsEbsVolumesIcon,
  AwsEc2SecurityGroupsIcon,
  AwsEfsFilesystemsIcon,
  AwsEksClustersIcon,
  AwsEmrClustersIcon,
  AwsEsDomainsIcon,
  AwsIamGroupsIcon,
  AwsIamUsersIcon,
  AwsKmsKeysIcon,
  AwsLambdaFunctionsIcon,
  AwsMacosInstancesIcon,
  AwsRdsDbInstancesIcon,
  AwsRedshiftClustersIcon,
  AwsRhelInstancesIcon,
  AwsS3BucketsIcon,
  AwsSnsTopicsIcon,
  AwsTotalEc2InstancesIcon,
  AwsUbuntuInstancesIcon,
  AwsVpcsIcon,
  AwsWindowsInstancesIcon,
} from "~/icons";

type AwsResourcesDynamicIconProps = {
  title: string;
  id?: string;
  className?: string;
  size?: string;
  defaultIcon?: typeof SvgIcon;
  sx?: SxProps;
};

export const AwsResourcesDynamicIcon = ({
  title,
  id,
  className,
  size,
  defaultIcon = AwsTotalEc2InstancesIcon,
  sx = {},
}: AwsResourcesDynamicIconProps) => {
  const commonProps = {
    id,
    className: `${className} aws-resource-icon`,
    "data-testid": "aws-resource-icon",
    sx: {
      fontSize: size || 24,
      ...(Array.isArray(sx) ? sx : [sx]),
    },
  };

  const iconKey = title.toLowerCase();
  const iconsDictionary: Record<string, typeof SvgIcon> = {
    "amazon linux instances": AwsAmazonLinuxInstancesIcon,
    "autoscaling groups": AwsAutoscalingGroupsIcon,
    "cloudwatch alarms": AwsCloudwatchAlarmsIcon,
    "cloudwatch log groups": AwsCloudwatchLogGroupsIcon,
    "config recorders": AwsConfigRecordersIcon,
    "dynamodb tables": AwsDynamodbTablesIcon,
    "ebs snapshots": AwsEbsSnapshotsIcon,
    "ebs volumes": AwsEbsVolumesIcon,
    "ec2 security groups": AwsEc2SecurityGroupsIcon,
    "efs filesystems": AwsEfsFilesystemsIcon,
    "eks clusters": AwsEksClustersIcon,
    "emr clusters": AwsEmrClustersIcon,
    "es domains": AwsEsDomainsIcon,
    "iam groups": AwsIamGroupsIcon,
    "iam users": AwsIamUsersIcon,
    "kms keys": AwsKmsKeysIcon,
    "lambda functions": AwsLambdaFunctionsIcon,
    "macos instances": AwsMacosInstancesIcon,
    "rds db instances": AwsRdsDbInstancesIcon,
    "redshift clusters": AwsRedshiftClustersIcon,
    "rhel instances": AwsRhelInstancesIcon,
    "s3 buckets": AwsS3BucketsIcon,
    "sns topics": AwsSnsTopicsIcon,
    "total ec2 instances": AwsTotalEc2InstancesIcon,
    "ubuntu instances": AwsUbuntuInstancesIcon,
    vpcs: AwsVpcsIcon,
    "windows instances": AwsWindowsInstancesIcon,
  };

  const Icon = iconsDictionary[iconKey] || defaultIcon;

  return <Icon {...commonProps} />;
};
